<!-- añadir siempre este div para englobar form -->
<div class="form-container perfilClienteForm">
  <mat-horizontal-stepper
    [linear]="isLinear"
    #stepper
    [@.disabled]="true"
    class="stepsForm"
  >
    <mat-step [stepControl]="firstPage">
      <h1>Perfil Cliente</h1>
      <form novalidate [formGroup]="firstPage" class="form__perfilCliente">
        <h2>Datos de la empresa</h2>
        <div class="datos__empresa">
          <mat-form-field appearance="outline">
            <mat-label for="razonSocial">Razón Social *</mat-label>
            <input
              matInput
              type="text"
              formControlName="razonSocial"
              id="razonSocial"
            />
            
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label for="nombreComercial">Nombre Comercial *</mat-label>

            <input
              matInput
              type="text"
              formControlName="nombreComercial"
              id="nombreComercial"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label for="cif">CIF *</mat-label>
            <input matInput type="text" formControlName="cif" id="cif" />
            <mat-error >Campo obligatorio, por favor introduzca un número de Cif válido</mat-error>
          </mat-form-field>
        </div>
        <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" 
        (onFileOver)="fileOver()" (onFileLeave)="fileLeave()">
        <ng-template ngx-file-drop-content-tmp 
            let-openFileSelector="openFileSelector">
            <ng-container *ngIf="nameDocumento">{{nameDocumento}}</ng-container>
              <ng-container *ngIf="!nameDocumento">Suba el logo de empresa</ng-container>
            <button type="button" class="boton_drop" (click)="openFileSelector()">Seleccionarlo</button>
        </ng-template>
        </ngx-file-drop>
        <h2>Domicilio Fiscal</h2>

        <div class="datos__fiscal">
          <mat-form-field appearance="outline" class="via">
            <mat-select placeholder="Tipo de Vía *" formControlName="via">
              <div *ngFor="let tipo of tiposVia">
                <mat-option value="{{ tipo }}">{{ tipo }}</mat-option>
              </div>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="nombre">
            <mat-label for="nombreVia">Nombre de la Vía *</mat-label>
            <input
              matInput
              type="text"
              formControlName="nombreVia"
              id="nombreVia"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="numero">
            <mat-label for="numeroVia">Nº *</mat-label>
            <input
              matInput
              type="text"
              formControlName="numeroVia"
              id="numeroVia"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="planta">
            <mat-label for="planta">Planta</mat-label>
            <input matInput type="text" formControlName="pta" id="pta" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="letra">
            <mat-label for="letra">Letra</mat-label>
            <input matInput type="text" formControlName="letra" id="letra" />
          </mat-form-field>
        </div>
        <div class="datos__fiscal2">
          <mat-form-field appearance="outline">
            <mat-label>Comunidad Autonoma *</mat-label>
            <mat-select formControlName="ccaa">
              <mat-option *ngFor="let autonomia of autonomias" [value]="autonomia" #matOption (click)="selectAutonomia(matOption)">
                {{autonomia}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
          <mat-form-field appearance="outline" *ngIf="provincias">
            <mat-label>Provincia *</mat-label>
            <mat-select formControlName="provincia">
              <mat-option *ngFor="let provincia of provincias" [value]="provincia" #matOption (click)="selectProvincia(matOption)">
                {{provincia.NOMBRE}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="municipios">
            <mat-label>Localidad *</mat-label>
            <mat-select formControlName="localidad">
              <mat-option *ngFor="let municipio of municipios" [value]="municipio"  #matOption (click)="selectMunicipio(matOption)">
                {{municipio.NOMBRE}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="cp">
            <mat-label for="codigoPostal">Código Postal *</mat-label>
            <input
              matInput
              type="text"
              formControlName="codigoPostal"
              id="codigoPostal"
            />
          </mat-form-field>
        </div>
        <div>
          <h2>Actividad de la Empresa</h2>
          <mat-form-field appearance="outline" class="motivo">
            <mat-label for="actividadEmpresa">
              Actividad de la empresa *
            </mat-label>
            <input
              matInput
              type="text"
              formControlName="actividadEmpresa"
              id="actividadEmpresa"
            />
          </mat-form-field>
          <h2>Motivo de alta</h2>
          <mat-form-field appearance="outline" class="motivo">
            <mat-select formControlName="motivoAlta" multiple>
              <div *ngFor="let motivo of motivosAlta">
                <mat-option value="{{ motivo }}">
                  {{ motivo }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <h2>Datos de contacto para sus Proveedores</h2>
          <mat-form-field appearance="outline" class="datosContacto">
            <mat-label for="datosContacto">
              Datos de contacto para proveedores *
            </mat-label>
            <input
              matInput
              type="text"
              formControlName="datosContacto"
              id="datosContacto"
            />
          </mat-form-field>
        </div>
        <p>* Campos Obligatorios</p>
        <div class="boton__siguiente">
          <button
            matStepperNext
            (click)="setCliente()"
            [disabled]="firstPage.invalid"
          >
            Siguiente
          </button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondPage">
      <div *ngIf="contactsFirstStep">
        <h1>Perfil Cliente</h1>
        <form novalidate [formGroup]="secondPage" class="form__perfilCliente">
          <h2>Datos del Responsable</h2>
          <div class="datos__responsable">
            <mat-form-field appearance="outline">
              <mat-label for="nombreContacto">
                Nombre y apellidos del Contacto
              </mat-label>

              <input
                matInput
                type="text"
                formControlName="nombreContacto"
                id="nombreContacto"
              />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label for="mailContacto">
                Mail de contacto
              </mat-label>
              <input
                matInput
                type="email"
                formControlName="mailContacto"
                id="mailContacto"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label for="cargo">Cargo / Departamento *</mat-label>
              <input matInput type="text" formControlName="cargoContacto" id="cargoContacto" />
            </mat-form-field>
          </div>
          
          <!-- <button class="boton__modificar">Modificar datos</button> -->
          
            <h2>Contactos adicionales</h2>
           
              <div class="datos__responsable">
                <mat-form-field appearance="outline">
                  <mat-label>Nombre y Apellido de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="nombreAdicional_0"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Mail de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="mailAdicional_0"
                  
                  />
                </mat-form-field>
        
                <mat-form-field appearance="outline">
                  <mat-label>Cargo / Departamento</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="cargoAdicional_0"
           
                  />
                </mat-form-field>
              </div>
              <div class="datos__responsable">
                <mat-form-field appearance="outline">
                  <mat-label>Nombre y Apellido de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="nombreAdicional_1"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Mail de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="mailAdicional_1"
                  />
                </mat-form-field>
        
                <mat-form-field appearance="outline">
                  <mat-label>Cargo / Departamento</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="cargoAdicional_1"
                  />
                </mat-form-field>
              </div>

              <div class="datos__responsable">
                <mat-form-field appearance="outline">
                  <mat-label>Nombre y Apellido de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="nombreAdicional_2"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Mail de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="mailAdicional_2"
                  />
                </mat-form-field>
        
                <mat-form-field appearance="outline">
                  <mat-label>Cargo / Departamento</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="cargoAdicional_2"
                  />
                </mat-form-field>
              </div>
              <div class="datos__responsable">
                <mat-form-field appearance="outline">
                  <mat-label>Nombre y Apellido de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="nombreAdicional_3"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Mail de Contacto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="mailAdicional_3"
                  />
                </mat-form-field>
        
                <mat-form-field appearance="outline">
                  <mat-label>Cargo / Departamento</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="cargoAdicional_3"
                  />
                </mat-form-field>
              </div>
         <div>
          <input type="checkbox" id="privacidad" formControlName="policy" />
          <label for="privacidad" id="privacidad" > He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a></label>
          <p id="proteccion">
            El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL. La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros.<br> Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
            </div>
            
       
          <p style="margin-top: 30px;">* Campos Obligatorios</p>
          <div class="boton__pasos">
            <button matStepperPrevious>Anterior</button>
            <button
              (click)="updateClienteById()"
              [disabled]="secondPage.invalid"
              [mat-dialog-close]
            >
              Finalizar
            </button>
          </div>
        </form>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
  
</div>
